<template>
  <v-flex xs12 class="align-self-stretch pb-5">
    <v-toolbar dense flat>
      <v-spacer></v-spacer>
      <v-toolbar-title>Dashboard</v-toolbar-title>
      <v-btn flat @click.native="toggleDisplay" v-tooltip:left="{ html: display.label }">
        <v-icon :primary="display.icon === 'list'">list</v-icon>
        <v-icon>swap_horiz</v-icon>
        <v-icon :primary="display.icon === 'grid_on'">grid_on</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-layout class="mt-2 wrap">
      <component :is="component" :display="display" :type="type" :title="title"></component>
    </v-layout>

    <v-bottom-nav shift value="true" class="primary">
      <v-btn :value="tab === 1" @click.native="tab = 1" class="white--text">
        <span>Utilizatori</span>
        <v-icon>person</v-icon>
      </v-btn>
      <v-btn :value="tab === 2" @click.native="tab = 2" class="white--text">
        <span>Clienti</span>
        <v-icon>business</v-icon>
      </v-btn>
      <v-btn :value="tab === 3" @click.native="tab = 3" class="white--text">
        <span>Setari</span>
        <v-icon>settings</v-icon>
      </v-btn>
      <v-btn :value="tab === 4" @click.native="tab = 4" class="white--text">
        <span>Flyers</span>
        <v-icon>insert_drive_file</v-icon>
      </v-btn>
      <v-btn :value="tab === 5" @click.native="tab = 5" class="white--text">
        <span>Download</span>
        <v-icon>cloud_download</v-icon>
      </v-btn>
      <v-btn :value="tab === 6" @click.native="tab = 6" class="white--text">
        <span>Dictionar</span>
        <v-icon>library_books</v-icon>
      </v-btn>
    </v-bottom-nav>

  </v-flex>
</template>

<script>
export default {
  components: {
    'tud-users': () => import('@/components/admin/Users.vue'),
    'tud-clients': () => import('@/components/admin/Clients.vue'),
    'tud-settings': () => import('@/components/admin/Settings.vue'),
    'tud-flyers': () => import('@/components/admin/Flyers.vue'),
    'tud-downloads': () => import('@/components/admin/Downloads.vue'),
    'tud-dictionary': () => import('@/components/admin/Dictionary.vue')
  },
  data () {
    return {
      tab: 1,
      display: {
        mode: 'list',
        icon: 'list',
        label: 'Display (*lista / tabel)'
      }
    }
  },
  computed: {
    component () {
      switch (this.tab) {
        case 1: return 'tud-users'
        case 2: return 'tud-clients'
        case 3: return 'tud-settings'
        case 4: return 'tud-flyers'
        case 5: return 'tud-downloads'
        case 6: return 'tud-dictionary'
      }
    },
    type () {
      switch (this.tab) {
        case 1: return 'User'
        case 2: return 'Client'
        case 3: return 'Setting'
        case 4: return 'Flyer'
        case 5: return 'Download'
        case 6: return 'Dictionary'
      }
    },
    title () {
      switch (this.tab) {
        case 1: return 'Utilizatori'
        case 2: return 'Clienti'
        case 3: return 'Setari'
        case 4: return 'Flyere'
        case 5: return 'Pagina download flyere'
        case 6: return 'Dictionary'
      }
    }
  },
  methods: {
    toggleDisplay () {
      this.display.mode = this.display.mode === 'list' ? 'table' : 'list'
      this.display.icon = this.display.icon === 'list' ? 'grid_on' : 'list'
      this.display.label = `Layout (${this.display.mode === 'list' ? '*lista / tabel' : 'lista / *tabel'})`
    }
  }
}
</script>

<style lang="stylus">
  .bottom-nav {
    left: 0;
    .btn {
      max-width: calc(100% / 3);
      .btn__content {
        width: 100%;
        padding: 0;

        span {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .admin-items-card {
    overflow: hidden;
    .card-list .list__tile__action {
      min-width: min-content;
    }
  }

  .card-navigation.pagination {
    height: 56px;
    .pagination__navigation {
      box-shadow: none;
      .icon {
        font-size: 1.4rem;
      }
    }

    .pagination__item {
      font-size: .8rem;
      width: calc(14px + .8rem);
      height: calc(14px + .8rem);
      box-shadow: none;
    }

    .pagination__item--active {
      box-shadow: none;
    }
  }

  .application--dark {
    table.table tbody tr:hover {
      background-color: #616161!important
    }

    .card-navigation.pagination {
      .pagination__navigation {
        .icon {
          color: white;
        }
      }

      .pagination__item {
        color: white;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?2d36198b